export const reminders = [
    {
        title: 'Watch Physics',
        date: '31 Aug 2017',
        status: 'danger',
        text: 'At your current speed you won\'t be done on due date. Speed up! Start Watching',
        type: 'flag',
    },
    {
        title: 'Compete with Sophia',
        date: '',
        status: 'info',
        text: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy.',
        type: 'star',
    },
    {
        title: '3Global Rushing',
        date: '',
        status: 'warning',
        text: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default mo',
        type: 'flight-land',
    },
    {
        title: 'Watch Physics',
        date: '31 Aug 2017',
        status: 'success',
        text: 'At your current speed you won\'t be done on due date. Speed up! Start Watching',
        type: 'trending-up',
    },
];


// WEBPACK FOOTER //
// ./src/data/reminders.js